<template>
  <div
    class="item"
    :class="{
      'in-cart': item.in_cart,
      'links-active': links_active,
      focus,
      defocus,
      selected,
      'with-extras': item.stickers || item.phase_id,
      'with-float': item.float_value,
      'slide': show_item_menu,
    }"
    @mouseenter="focusIn()"
    @mouseleave="focusOut()"
    @click.right.prevent="openItemPreview"
    @mousedown.middle.prevent="middleClickRedirect"
  >
    <div ref="item_wrapper" class="item-wrapper" :class="[item.app_id === APP_ID.cs2 ? `quality-${item.quality_id}` : `quality-${(item.quality || '').toLowerCase()}`]">
      <component :is="link ? BamLink : 'div'" ref="content" :to="link" class="item-content">
        <div class="top flex">
          <slot name="itemTop" />
          <ItemPhase v-if="!phaseInline" :item="item" />
        </div>
        <slot name="price">
          <div v-if="item.out_of_stock" class="item-price out-of-stock-details">
            <div class="btns-row">
              <div class="btn btn-out img-l">
                <img src="@/asset/icon/lock2.svg" alt="icon"> <span>{{ $t('market.out_of_stock') }}</span>
              </div>
              <a v-if="find_similar_item" href="#" class="btn btn-transparent img-r btn-find link-secondary" rel="nofollow noopener noreferrer" target="_blank" @click.prevent.stop="openLink(router.resolve(find_similar_item_url).href)">
                <span>{{ $t('market.find_similar_item') }}</span> <img src="@/asset/icon/arrow-full-right-green.svg" alt="icon">
              </a>
            </div>
            <div class="text">{{ $t('market.checkout.this_item_will_not_be_included') }}</div>
          </div>
          <ItemPrice v-else :price="item.price" :suggested_price="item.suggested_price" :inline="inline" :show_discount="show_discount" />
        </slot>
        <template v-if="item.ss >= 1 && !keep_steam_image">
          <ItemPreview
            ref="item_preview"
            :style="picture_wrapper ? `top: ${picture_wrapper.offsetTop}px` : 'top: 130px'"
            :item="item"
            :side="is_right"
          />
        </template>
        <div ref="picture_wrapper" class="picture-wrapper" @mousemove="pictureMouseIn">
          <ItemPicture
            :hide="is_right && !!item?.thumbnail_reverse"
            :resize="!item.thumbnail"
            :img="item_picture"
            :width="rwd_picture_width"
            :height="rwd_picture_height"
            :fallback="item.icon"
          >
            <template v-if="item?.thumbnail_reverse" #default>
              <BamLazyImg
                v-if="is_right"
                img-class="img-item"
                :src="item.thumbnail_reverse"
                :fallback="item.icon"
              />
            </template>
          </ItemPicture>
        </div>
        <ItemName :item="item" :sub="sub" />
        <ItemFloat v-if="item.float_value" :value="item.float_value" :float_rank="item.float_rank" :fixed="6" :paint_id="item.paint_id" />
        <ItemExtras resize width="40" height="30" :tooltip-position="tooltip_position" :item="item" :phase-inline="phaseInline" />
        <template v-if="logged && !($route.name === ROUTE.store && item.is_mine)">
          <div
            v-if="selected || item.is_mine || (!bot && (item.locked || item.skin_status !== 1))"
            class="item-checkmark"
            :class="{ yellow: (!bot && item.locked), red: (!bot && item.skin_status !== 1), 'own': item.is_mine }"
          >
            <img v-if="selected" src="@/asset/icon/checkmark-circle.svg" alt="icon">
            <img v-if="(!bot && item.skin_status !== 1)" src="@/asset/icon/not-allowed.svg" alt="icon" class="svg-white">
            <img v-else-if="(!bot && item.locked)" src="@/asset/icon/timer-white.svg" alt="icon">
            <div v-if="item.is_mine" class="inner">
              <img src="@/asset/icon/hands-box.svg" alt="icon">
            </div>
            <p v-if="item.is_mine">{{ $t('market.this_is_your_item') }}</p>
            <p v-if="!bot && item.skin_status !== 1">{{ $t('market.not_accepting') }}</p>
            <p v-else-if="!bot && item.locked">{{ $t('market.trade_hold.name') }}</p>
          </div>
        </template>
        <slot name="itemContent" />
      </component>
      <div v-if="links && links_active" class="item-links" @click.stop>
        <slot name="itemLinks" />
        <BamLink v-if="props.item.id" rel="nofollow noopener noreferrer" target="_blank" :to="getItemTo(props.item)" class="flex-row">
          <img src="@/asset/icon/external-link.svg" class="mr-15" alt="icon"><span>{{ $t('market.action.item_page') }}</span>
        </BamLink>
        <a v-if="item.screenshot" :href="item.screenshot" rel="nofollow noopener noreferrer" target="_blank" class="flex-row">
          <img src="@/asset/icon/frame.svg" class="mr-15" alt="icon"> <span>{{ $t('market.action.screenshot') }}</span> </a>
        <a v-if="links.includes(ITEM_LINK.inspect) && urls.inspect_url" :href="urls.inspect_url" rel="nofollow noopener noreferrer" target="_blank" class="flex-row">
          <img src="@/asset/icon/eye.svg" class="mr-15" alt="icon"> <span>{{ $t('market.action.inspect') }}</span> </a>
        <BamLink v-if="links.includes(ITEM_LINK.check_on_market) && urls.market_to && (bot || item.skin_status)" rel="nofollow noopener noreferrer" target="_blank" :to="urls.market_to" class="flex-row">
          <img src="@/asset/icon/money-house.svg" class="mr-15" alt="icon"> <span>{{ $t('market.action.check_on_market') }}</span>
        </BamLink>
        <component :is="is_steam_visible_tag" v-if="links.includes(ITEM_LINK.view_at_steam) && urls.steam_url" :href="is_steam_visible_link" :class="{'disabled': !is_steam_visible}" rel="nofollow noopener noreferrer" target="_blank" class="flex-row">
          <div v-if="!is_steam_visible" v-tooltip="{ message: $t('market.action.view_at_steam_tooltip', { when: when_is_steam_visible }), position: 'center top', remove_immediately: true }" class="overlay" />
          <img src="@/asset/icon/social/steam.svg" class="mr-15" :class="{'svg-grey': !is_steam_visible}" alt="icon">
          <span>{{ $t('market.action.view_at_steam') }}</span>
        </component>
        <BamLink v-if="status.buy_order && links.includes(ITEM_LINK.create_buy_order) && item.skin_id" class="flex-row" :to="{ query: { popup: POPUP.BuyOrderCreate, id: item.skin_id } }" @click.prevent="$router, checkUserLogged($router, () => openPopup($router, POPUP.BuyOrderCreate, { id: item.skin_id }))">
          <img src="@/asset/icon/calculator.svg" class="mr-15" alt="icon"> <span>{{ $t('market.create_buy_order') }}</span>
        </BamLink>
        <!--        <BamLink v-if="links.includes(ITEM_LINK.bulk_buy) && item.skin_id" class="flex-row" :to="{ query: { popup: POPUP.BulkBuy, id: item.skin_id } }" @click.prevent="checkUserLogged($router, () => openPopup($router, POPUP.BulkBuy, { id: item.skin_id }))">-->
        <!--          <img src="@/asset/icon/basket.svg" class="mr-15" alt=""> <span>{{ $t('market.action.bulk_buy') }}</span>-->
        <!--        </BamLink>-->
        <button v-if="links.includes(ITEM_LINK.favorites) && !item.is_mine" class="flex-row" :class="{ 'cursor-wait': toggle_favorite_disabled }" @click="checkUserLogged($router, () => toggleFavorite(item))">
          <template v-if="isFavorite(item)">
            <img src="@/asset/icon/heart-plus-red.svg" class="mr-15" alt="icon"> <span>{{ $t('market.action.remove_from_favorites') }}</span>
          </template>
          <template v-else>
            <img src="@/asset/icon/heart-plus-white.svg" class="mr-15" alt="icon"> <span>{{ $t('market.action.add_to_favorites') }}</span>
          </template>
        </button>
        <button v-if="links.includes(ITEM_LINK.buy) && !item.is_mine" class="flex-row" @click="checkUserLogged($router, () => openBuy(item))">
          <img src="@/asset/icon/thunder.svg" class="mr-15" alt="icon"> <span>{{ $t('market.action.buy_now') }}</span>
        </button>
        <BamLink
          v-if="links.includes(ITEM_LINK.bump) && item.is_mine && item.status === INVENTORY_STATUS.listed && item.suggested_price >= BUMPING.minimum_price"
          class="flex-row"
          :to="{ query: { popup: POPUP.BumpStart, id: item.id, app_id: item.app_id } }"
          @click.prevent="checkUserLogged($router, () => openPopup($router, POPUP.BumpStart, { id: item.id, app_id: item.app_id }))"
        >
          <img src="@/asset/icon/rocket-small.svg" class="mr-15" alt="icon"> <span>{{ $t('market.action.bump') }}</span>
        </BamLink>
        <slot name="itemLinksAfter" />
      </div>
    </div>
    <div v-if="links" class="item-menu" @click.stop>
      <div class="btns-row">
        <slot name="itemBtns" />
        <button ref="button" class="btn btn-primary btn-om btn-more" aria-label="More actions" @click="toggleActive">
          <span /> <span /> <span />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ITEM_LINK, POPUP, ROUTE } from '@/facade/enum.js';
import { getItemTo, getUrls, getMarketSearch, isSteamVisible, whenIsSteamVisible } from '@/helper/steam.js';
import { openBuy } from '@/hook/market/buy.js';
import { addFavorite, isFavorite, removeFavorite } from '@/hook/market/favorite.js';
import { status } from '@/hook/status.js';
import { INVENTORY_STATUS, APP_ID, STEAM_VISIBILITY_AFTER_DAYS } from '@common/enum/market.js';
import { BUMPING } from '@common/enum/market/bump.js';
import { useCooldown } from 'bambam-helper/timed.js';
import { computed, defineAsyncComponent, onBeforeUnmount, onMounted, ref } from 'vue';
import { openPopup } from '@/hook/system/popup.js';
import { session, router } from '@/main.js';
import { BamLink } from 'bambam-router';
import { checkUserLogged } from '@/helper/user.js';
import { APP_EVENT_BUS, main_bus } from '@/hook/bus.js';
import { useSettings } from '@/hook/settings.js';
import { openLink } from 'bambam-helper/dom.js';
import ItemPrice from '@/component/item/ItemPrice.vue';
import ItemPicture from '@/component/item/ItemPicture.vue';
import ItemName from '@/component/item/ItemName.vue';
import ItemFloat from '@/component/item/ItemFloat.vue';

const ItemPhase = defineAsyncComponent(() => import('@/component/item/ItemPhase.vue'));
const ItemExtras = defineAsyncComponent(() => import('@/component/item/ItemExtras.vue'));
const ItemPreview = defineAsyncComponent(() => import('@/component/item/ItemPreview.vue'));
const BamLazyImg = defineAsyncComponent(() => import('bambam-component-core/BamLazyImg.vue'));

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  links: {
    type: [Array, Boolean],
    default: () => [],
  },
  selected: {
    type: Boolean,
  },
  bot: {
    type: Boolean,
    default: true,
  },
  sub: {
    type: Boolean,
    default: null,
  },
  a: {
    type: Boolean,
    default: true,
  },
  inline: {
    type: Boolean,
    default: false,
  },
  phaseInline: {
    type: Boolean,
    default: false,
  },
  show_discount: {
    type: Boolean,
    default: true,
  },
  find_similar_item: {
    type: Boolean,
    default: true,
  },
  tooltip_position: {
    type: String,
  },
  picture_width: {
    type: String,
    default: '176',
  },
  picture_height: {
    type: String,
    default: '132',
  },
  keep_steam_image: {
    type: Boolean,
    default: false,
  },
});

const content = ref();
const links_active = ref();

const toggleActive = () => {
  links_active.value = !links_active.value;
};

const button = ref();

const outsideClickListener = event => {
  if (!button.value?.contains(event.target)) {
    links_active.value = false;
  }
};

const is_right = ref(false);
const item_picture = computed(() => (props.keep_steam_image ? props.item.icon : (props.item.thumbnail || props.item.icon)));
const rwd_picture_width = computed(() => props.picture_width);
const rwd_picture_height = computed(() => props.picture_height);
const item_wrapper = ref();

const pictureMouseIn = (e) => {
  const half = item_wrapper.value.clientWidth / 2;
  const pos = e.offsetX;

  is_right.value = pos > half;
};

const picture_wrapper = ref();

onMounted(() => {
  document.addEventListener('click', outsideClickListener);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', outsideClickListener);
});

const focus = ref(false);
const defocus = ref(false);
let timeout;
const focusIn = () => {
  clearTimeout(timeout);
  focus.value = true;
  defocus.value = false;
};
const focusOut = () => {
  clearTimeout(timeout);
  focus.value = false;
  defocus.value = true;
  timeout = setTimeout(() => {
    links_active.value = false;
    focus.value = false;
  }, 200);
};

onBeforeUnmount(() => {
  clearTimeout(timeout);
});

const { profile, logged } = session;
const urls = computed(() => getUrls(props.item, props.bot ? props.item?.bot_steam_id : profile.value.steam_id));

const sub = computed(() => {
  if (props.sub === null) {
    return Boolean(props.item.exterior || props.item.quality || props.item.hero || props.item.type);
  }
  return props.sub;
});

const link = computed(() => props.a && getItemTo(props.item));

const { action: toggleFavorite, disabled: toggle_favorite_disabled } = useCooldown((item) => (isFavorite(item) ? removeFavorite(item) : addFavorite(item)), 5e3);

const { show_item_menu } = useSettings();

main_bus.on(APP_EVENT_BUS.slideItems, (v) => {
  show_item_menu.value = v;
});

const find_similar_item_url = computed(() => getMarketSearch(props.item, { skin_name: props.item.name }, null, [{ field: 'price', order: 'ASC' }]));

const item_preview = ref();
const openItemPreview = () => {
  if (item_preview.value) {
    item_preview.value.openItemPreview();
  }
};

const middleClickRedirect = () => {
  if (!props.a && props.item.id) {
    openLink(router.resolve(getItemTo(props.item)).href, '_blank');
  }
  if (!props.a && !props.item.id) {
    openLink(urls.value.steam_url, '_blank');
  }
};

const is_steam_visible = computed(() => isSteamVisible(props.item.created_at, STEAM_VISIBILITY_AFTER_DAYS[props.item.app_id]));
const when_is_steam_visible = computed(() => whenIsSteamVisible(props.item.created_at, STEAM_VISIBILITY_AFTER_DAYS[props.item.app_id]));
const is_steam_visible_tag = computed(() => (is_steam_visible.value ? 'a' : 'div'));
const is_steam_visible_link = computed(() => (is_steam_visible.value ? urls.value.steam_url : '#'));
</script>
